import { useEffect, useState } from 'react';
import AppItemList from './AppItemList';

type List = ListItem[];

export type ListItem = {
    name: string;
    description: string;
    urlPre: string[];
    urlProd: string[];
}

const AppList = () => {
    const [appList, setAppList] = useState<List>([]);

    const [openIndex, setOpenIndex] = useState<number | null>(0);

    const toggleAccordion = (index: number) => {
        if (openIndex === index) {
            setOpenIndex(null);
        } else {
            setOpenIndex(index);
        }
    };

    useEffect(() => {
        fetch('/applist.json')
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                setAppList(data);
                console.log(data, 'appList');
            })
            .catch((error) => {
                console.error('Error fetching the JSON file:', error);
            });
    }, []);
    return (
        <div className='rounded-xl bg-slate-50 w-11/12 p-5 border border-green-600 shadow-xl'>
            <div className="w-full space-y-4">
                {appList.map((app, index) => (
                    <AppItemList key={index} app={app} index={index} openIndex={openIndex} toggleAccordion={toggleAccordion} />
                ))}

            </div>
        </div>
    )
}

export default AppList